import React, { FC } from "react";

import { Switch, SwitchProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import {
  ColorDisabled,
  ColorError,
  ColorPrimary,
  ColorSecondary,
} from "./theme";

export const StyledSwitch: any = styled(Switch)(({ theme }) => ({
  width: "34px",
  height: "20px",
  margin: "10px 5px 10px 5px",
  padding: "0px",
  display: "flex",
  borderRadius: "15px",
  border: "2px solid rgba(0, 0, 0, 1)",
  "& .MuiSwitch-input": {
    height: "20px",
  },
  "&:active": {
    borderColor: theme.palette.primary.main,
    "& .MuiSwitch-thumb": {
      width: "8px",
      height: "8px",
      boxShadow: "none",
      color: theme.palette.primary.main,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(14px)",
      color: theme.palette.primary.main,
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "white",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    marginLeft: "2px",
    marginTop: "2px",
    color: theme.palette.secondary.main,
    width: "8px",
    height: "8px",
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: "15px",
    opacity: 1,
    backgroundColor: "white",
    boxSizing: "border-box",
  },
}));

interface IgSwitchProps extends SwitchProps {}

/**
 * @see Switch
 */
export const IgSwitch: FC<
  IgSwitchProps & { children?: any; redOff?: boolean }
> = (props) => {
  const { children, checked, disabled, onClick, sx, redOff, ...rest } = props;

  return (
    // @ts-ignore
    <StyledSwitch
      checked={checked}
      onClick={disabled ? undefined : onClick}
      sx={{
        borderColor: disabled
          ? `${ColorDisabled.main} !important`
          : checked
            ? ColorPrimary.main
            : redOff
              ? ColorError.light2
              : ColorSecondary.main,
        "& .MuiSwitch-thumb": {
          color: disabled
            ? `${ColorDisabled.main} !important`
            : checked
              ? ColorPrimary.main
              : redOff
                ? ColorError.light2
                : ColorSecondary.main,
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </StyledSwitch>
  );
};
